import { Tool } from "@/types/content";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

interface ToolCardProps extends Tool {
  index: number;
}

export const ToolCard = ({ title, description, icon: Icon, link, index }: ToolCardProps) => {
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      viewport={{ once: true }}
      className="p-6 bg-white rounded-2xl shadow-sm hover:shadow-md transition-all duration-200 group cursor-pointer"
      onClick={() => navigate(link)}
    >
      <div className="mb-4 text-spirit-600 flex justify-center">
        <Icon className="w-8 h-8 group-hover:scale-110 transition-transform duration-200" />
      </div>
      <h3 className="text-xl font-medium text-gray-900 mb-2">
        {title}
      </h3>
      <p className="text-gray-600">{description}</p>
    </motion.div>
  );
};